import { EnumObj } from "./EnumObj";

export const EStatusArquivo = {
  VIGENTE: new EnumObj("dd94c8f4-11d4-40a3-9c7f-794ca5c9cf9d", "Vigente", 0),
  OBSOLETO: new EnumObj("6a07d46b-12f9-4639-b882-f7966777a9aa", "Obsoleto", 0),
  VALIDO: new EnumObj("4cd5c4f6-a880-487e-a374-eaa515bfd70d", "Válido", 0),
  INVALIDO: new EnumObj("746fdd7d-214c-40ab-a772-209051295551", "Inválido", 0),
  ENVIADO: new EnumObj("668eeded-90c8-48e2-8180-5a9231f2c85b", "Enviado", 0),
  AGUARDANDO_ENVIO: new EnumObj("b0015845-52e6-4ab9-9014-2a2ac70a62d1", "Aguardando envio", 0),
  VALIDADO: new EnumObj("64d644dd-01af-48a6-88db-949d93df8a72", "Válidado", 0),
  PENDENTE: new EnumObj("bc2e127f-c266-4788-9503-5083cef7856e", "Pendente", 0),
}

export const getEStatusArquivoById = (id: string): EnumObj | undefined => {
  var arryTipos = Object.values(EStatusArquivo);
  return arryTipos.find(t => t.id == id);
};